import application from 'application/application';
import modalSendEmailTemplate from './modal-send-email.template.html';

import modalSendEmailController from './modal-send-email.controller.js';

application.directive('ngModalSendEmail', [
	() => ({
		restrict: 'E',
		templateUrl: modalSendEmailTemplate,
		controller: modalSendEmailController
	})
]);
